import { SafeHtml } from '@angular/platform-browser';

import { Classification, ClassificationReason } from 'src/enums/classification';

import { TestResult } from './testResult';
import { Property } from './property';
import { UF } from './uf';
import { ProductProperty } from './productProperty';
import { Version } from './version';
import { OffboardComponent } from './offboardComponent';
import { TestSpecification } from './testSpecification';

export class TestRunViewModel {
	public testRun: TestRun;

	public testSuite: TestSuite;

	public testSpecification: TestSpecification;

	public ecuAndSwIdentifiers?: EcuAndSwIdentifiers[];

	public testRunType: number;

	public testSuiteVersion: number; //Test suite version for calling test suite
}

export class TestRun {
	public testRunUid: string;

	public executionTime: Date;

	public importTime: Date;

	public environment: string;

	public vinNo: string;

	public configuration: string;

	public sop: string;

	public testPeriod: string;

	public classification: Classification;

	public classificationReason: ClassificationReason;

	public classificationComment: string;

	public status: string;

	public regBy: string;

	public regTime: Date;

	public testResults: TestResult[];

	public expaned = false;
}

export interface TestRunAndProperties {
	testRunUid: string;
	executionTime: Date;
	properties: Property[];
}

export class TestSuite {
	public testSuiteUid: string;

	public itemNo: string;

	public name: string;

	public expaned = false;

	public version: number;

	public ufs: UF[];

	public owners: string[];

	public productProperties: ProductProperty[];

	public versions: Version[];

	public offboardComponents: OffboardComponent[];

	public parentTestSuiteUid: string;

	public parentVersion: string;

	public childrenTestSuites: TestRunViewModel[];

	public description: string;

	public descriptionSafeHtml: SafeHtml;

	public regBy: string;

	public regTime: Date;

	public parentUid: string;

	public testSuites: TestSuite[];
}

export class TestSuiteAlternative {
	public uid: string;

	public version: number;

	public name: string;

	public label: string;

	public fromDate: Date;

	public toDate: Date;

	public validFromSop: string;

	public validToSop: string;

	public regBy: string;

	public regTime: Date;

	public properties: Property[];

	public testGroups: string[];
}

export class TestRunStatistics {
	public inputStatistics: InputStatistic[];
}

export class InputStatistic {
	public type: string;

	public count: number;
}

export interface EcuAndSwIdentifiers {
	name: string;
	swIdentifiers: string;
}
